module.exports = __webpack_public_path__ + "img/xzsj.3d462c76.svg";